<div class="overflow-auto">
    <table style="width: 100%; margin-bottom: 10px;">
        @if (isDocumentProcessing && currentDocument?.clientInstanceId) {
            <tr>
                <td>Client Instance</td>
                <td>{{ currentDocument.clientInstanceName }}</td>
            </tr>
        }
        @for (filter of criteria.activeFilters | sortBy: 'asc':'sequenceNum'; track filter; let i = $index) {
            <tr class="search-filter delete-hover">
                <td class="text-start" style="width: 140px;">
                    {{ filter.name }}
                </td>
                <td>
                    @if (!filter.dropdown && filter.field !== 'taxYear') {
                        <auto-populate-input [name]="'search-filter-' + i"
                                             [inputClass]="'search-filter-' + i"
                                             [inputIndex]="i"
                                             [(ngModel)]="filter.text"
                                             [idpResults]="filter.idpResults"
                                             [currentDocument]="currentDocument"
                                             (ngModelChange)="changeResultType()"
                                             (focusout)="searchCriteriaUpdated(filter)">
                        </auto-populate-input>
                    }
                    @if (filter.field === 'taxYear') {
                        <auto-populate-input [name]="'search-filter-' + i"
                                             [inputClass]="'search-filter-' + i"
                                             [inputIndex]="i"
                                             [isDateInput]="true"
                                             [(ngModel)]="filter.text"
                                             [idpResults]="filter.idpResults"
                                             [currentDocument]="currentDocument"
                                             (ngModelChange)="changeResultType()"
                                             (focusout)="searchCriteriaUpdated(filter)">
                        </auto-populate-input>
                    }
                    @if (filter.field === 'siteStateAbbr') {
                        <state-dropdown [(stateAbbr)]="filter.text"
                                        (stateAbbrChange)="changeResultType()"
                                        [canSearch]="true"
                                        [includeBlank]="true"
                                        [useHtmlSelect]="true"
                                        [styleClass]="'search-filter-' + i">
                        </state-dropdown>
                    }
                    @if (filter.field === 'parcelPropType') {
                        <select class="form-select form-select-sm"
                                [ngClass]="'search-filter-' + i"
                                [attr.data-qa]="'search-filter-' + i"
                                [(ngModel)]="filter.text"
                                (change)="changeResultType()">
                            @for (propertyType of propertyTypes; track propertyType) {
                                <option [attr.data-qa]="'property-type-item-' + i"
                                        [value]="propertyType.propTypeAbbr">
                                    {{ propertyType.propTypeAbbr }}
                                </option>
                            }
                        </select>
                    }
                </td>
                <td class="align-middle" style="width: 30px;">
                    <i class="fa fa-close hidden-hover"
                       aria-label="Remove Filter"
                       aria-hidden="true"
                       [attr.data-qa]="'remove-filter-button-' + i"
                       helpTooltip
                       [tooltipText]="'Remove'"
                       [position]="'bottom'"
                       (click)="removeFilter(filter, i)" tabindex="-1">
                    </i>
                </td>
            </tr>
        }
    </table>
</div>
@if ((isOpen || isDocumentProcessing) && criteria.inactiveFilters?.length !== 0) {
    <div
        #dropdown="bs-dropdown"
        dropdown
        container="body"
        style="margin-left: 22px;">
        <button type="button"
                class="ace-btn has-icon btn-secondary fa fa-plus"
                aria-label="Add Filter"
                title="Add"
                [attr.data-qa]="'add-quick-search-filter-button'"
                (click)="addFilterButtonClicked()"
                dropdownToggle>
        </button>
        <ul *dropdownMenu class="dropdown-menu" role="menu">
            @for (filter of criteria.inactiveFilters | sortBy: 'asc': 'name'; track filter; let i = $index) {
                <li>
                    <span tabindex="0"
                            class="dropdown-item pointer"
                          (click)="addFilter(filter)"
                          [attr.data-qa]="'quick-search-filter-item-' + i">{{ filter.name }}</span>
                </li>
            }
        </ul>
    </div>
}
<div class="float-end">
    <div style="display: inline-block; margin-right: 10px; vertical-align: middle;">
        Results
    </div>
    <div style="display: inline-block; margin-right: 10px; vertical-align: middle;">
        <select [(ngModel)]="criteria.resultType"
                class="form-select form-select-sm"
                data-qa="quick-search-result-type">
            @for (option of resultTypes | sortBy: 'asc':'id'; track option; let i = $index) {
                <option [value]="option.type" [attr.data-qa]="'quick-search-result-type-' + i">{{ option.name }}
                </option>
            }
        </select>
    </div>
    <div class="checkbox" style="display: inline-block; margin: 0 10px; vertical-align: middle;">
        <div>
            <label>
                <input [(ngModel)]="criteria.primaryAcctNumOnly"
                       data-qa="quick-search-primary-acct-num-only"
                       type="checkbox">
                Primary Acct Num Only
            </label>
        </div>

    </div>
    <div class="checkbox" style="display: inline-block; margin: 0 10px; vertical-align: middle;">
        <div>
            <label>
                <input [(ngModel)]="criteria.activeOnly"
                       data-qa="quick-search-exclude-inactive"
                       type="checkbox"> Exclude Inactive
            </label>
        </div>
        @if (showAnticipated()) {
            <div>
                <label>
                    <input type="checkbox"
                           [(ngModel)]="criteria.anticipated"
                           data-qa="quick-search-anticipated">
                    Anticipated
                </label>
            </div>
        }
    </div>
    <button (click)="submitSearch()"
            aria-label="Start Search"
            class="ace-btn has-icon btn-primary fa fa-search"
            data-qa="quick-search-submit-button"
            title="Search">
    </button>
</div>
<div class="clearfix"></div>
